import { BaseCriteriaModel } from '../base-criteria.model';
import { Optional } from 'typescript-optional';

export class RateEventQueryCriteriaClass extends BaseCriteriaModel {
  //For bl_pgw_merchant_rate_event

  guid?: Optional<string> = Optional.empty();
  hdr_guid?: Optional<string> = Optional.empty(); /** @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/
  txn_type?: Optional<string> = Optional.empty();
  action?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  id_user?: Optional<string> = Optional.empty();

}

export class RateEventCriteriaModelQuery {
  query = '';

  constructor(RateEventCriteriaModel: RateEventQueryCriteriaClass) {
    console.log('rcEventCriteriaModel', RateEventCriteriaModel);

    if (!RateEventCriteriaModel) {
      return;
    }

    this.query += RateEventCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += RateEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guids=' + x).orElse('');
    this.query += RateEventCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += RateEventCriteriaModel.action.filter(x => x !== '').map(x => '&action=' + x).orElse('');
    this.query += RateEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += RateEventCriteriaModel.id_user.filter(x => x !== '').map(x => '&id_user=' + x).orElse('');


    this.query += '&status=' + RateEventCriteriaModel.status;
    this.query += '&orderBy=' + RateEventCriteriaModel.orderBy;
    this.query += '&order=' + RateEventCriteriaModel.order;
    this.query += '&offset=' + RateEventCriteriaModel.offset + '&limit=' + RateEventCriteriaModel.limit;
  }

}
